module.exports = __webpack_public_path__ + "static/media/bzj_ic_xinyonglianghao.26195768.png";